import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import PopupModal from "../../../components/Modal/PopupModal";
import "./Features.scss";

const featureData = [
  {
    mainHeading: "Purchase Partner Management",
    cardContent: [
      {
        title:
          "Procurement Software That Simplifies Your Business Process And Saves Money",
        titleContent:
          "Efficiently manage and collaborate with business partners using a robust, automated platform.",
        points: [
          {
            pcontent: "Deriving Value From Vendors",
            pcontents: "Deriving Value From Vendors",
            paracontent:
              "Vendor discovery and management can be time-consuming. VENSAP, a leading procurement software in India, simplifies vendor onboarding by enabling secure vendor logins that reduce manual data entry, processing time, and operational costs.",
            activecontent:
              "Configure vendor evaluation and approval workflows aligned with company policies,Guide vendors through a smooth and compliant onboarding journey,Enable effective communication to build long-term supplier partnerships",
            // icon: "bi bi-person-plus",
            icon: "bi bi-people-fill",
          },
          {
            pcontent: "Smart Purchase Requisition",
            pcontents: "Smart Purchase Requisition",
            paracontent:
              "Start your procurement journey effortlessly with VENSAP. Our purchase requisition module allows quick creation, submission, and approval of PRs—saving time and reducing manual work.",
            activecontent:
              "Seamless multi-department PR approval workflows,Bulk PR creation through Excel imports,Automatic archiving of PRs after approval",
            // icon: "bi bi-person-x",
             icon: "bi bi-file-earmark-text",
          },
          {
            pcontent: "Transparent Quotation Management",
            pcontents: "Transparent Quotation Management",
            paracontent:
              "Streamline vendor quotation processes with an intelligent quotation management module that reduces effort, improves transparency, and accelerates approvals.",
            activecontent:
              "Request and manage vendor quotations with a single click,Automatically compare quotations and share results with management,Ensure compliance with company quotation policies",
            // icon: "bi bi-diagram-3",
            icon: "bi bi-receipt-cutoff",
          },
          {
            pcontent: "Seamless Purchase Order Processing",
            pcontents: "Seamless Purchase Order Processing",
            paracontent:
              "Once a purchase requisition is approved, a purchase order is issued to the vendor with complete purchase details. VENSAP simplifies this process by auto-generating POs from approved PRs.",
            activecontent:
              "Automatic PO creation with easy email approvals,Accurate order tracking with predefined vendor rates,Inbuilt GST compliance for hassle-free taxation,Ideal for organizations operating within defined budgets.",

            // icon: "bi bi-ui-checks-grid",
             icon: "bi bi-cart-check", // purchase order
          },

          {
            pcontent: "GRN & Quality Control Management",
            pcontents: "GRN & Quality Control Management",
            paracontent:
              "VENSAP provides a controlled and flexible GRN process, allowing organizations to receive goods and perform quality checks as per operational needs while ensuring accuracy and compliance.",
            activecontent:
              "Automatically generate GRNs with quality check integration,Enable instant approvals for received goods,Communicate discrepancie -damages or rejections to procurement teams,Maintain a reliable inventory database for accurate invoicing.",
            // icon: "bi bi-alarm",
              icon: "bi bi-clipboard-check",
          },

          {
            pcontent: "Payment Management & Control",
            pcontents: "Payment Management & Control",
            paracontent:
              "VENSAP enables structured and secure vendor payment management while ensuring transparency and efficiency.",
            activecontent:
              "Execute payments across multiple invoices in a single transaction,Enable real-time alerts for payment due and overdue invoices,Allow partial invoice payments with complete tracking.",
            // icon: "bi bi-chat-left-dots",
            icon: "bi bi-credit-card-2-front",
          },
          {
            pcontent: "Smart Recurring Invoice Management",
            pcontents: "Smart Recurring Invoice Management",
            paracontent:"Ensure consistent, on-time payments by automating recurring invoices with flexible scheduling and controls.",
            activecontent:
              "Send tailored invoices with complete accuracy,Schedule invoices in advance,Add billing details in one go,Make quick changes to invoice data,Pause or stop payments as per business needs,Hold vendor payments at the invoice level for a financial year.",
            // icon: "bi bi-file-earmark-pdf",
                icon: "bi bi-arrow-repeat", 
          },
        ],
      },
    ],
    underLine: "<hr/>",
  },
  {
    mainHeading: "Customer Sales Management",
    cardContent: [
      {
        title: "Gain complete visibility into your sales process with an intelligent Sales Order Management solution.",
        titleContent:
          "Manage and automate the complete order-to-cash process with a robust sales operations management system.",
        points: [
          {
            pcontent: "Sales-Focused",
            pcontents: "Sales-Focused",
            paracontent:"An intelligent quotation management system helps sales teams respond faster and close deals quicker. From quotation creation to invoice generation, every step is streamlined to improve accuracy and productivity.",
            activecontent:"Automated quotation creation and approval,Centralized customer quotation records,Quick and effortless quotation sharing,One-click conversion to sales orders or invoices,Intuitive dashboard for real-time quotation monitoring,Pro-forma invoice generation for early billing needs",
            icon: "bi bi bi-file-check",
          },
          {
            pcontent: "End-to-End Sales Control",
            pcontents: "End-to-End Sales Control",
            paracontent:"Sales Order Management ensures error-free order processing while maintaining compliance with pricing, discount, and credit policies. With real-time tracking and automation, sales teams can focus more on closing deals and less on manual tasks.",
            activecontent:"End-to-end automation of sales order creation and approvals,Self-service customer portal for raising sales orders,Accurate pricing management at customer and item levels,Controlled discounting to protect margins,Automatic communication of approved sales orders,Credit-controlled order processing,Proactive alerts to prevent missed sales opportunities",
            icon: "bi  bi-send-check",
          },
          {
            pcontent: "Invoice Management",
            pcontents: "Invoice Management",
            paracontent:"Invoice Management enables businesses to bill faster, reduce errors, and maintain full tax compliance. With flexible approval workflows and automated GST handling, teams gain complete control over sales invoicing operations.",
            activecontent:"Rule-based invoice approvals for better financial control,Auto-send invoices directly to customers,Notifications for recurring billing cycles,Schedule invoices ahead of time,Built-in GST automation across locations",
            icon: "bi bi-cash-stack",
          },
          {
            pcontent: "Customer Payment Management",
            pcontents: "Customer Payment Management",
            paracontent:"Collection Management enables finance teams to gain full control over receivables while improving customer payment experiences. Automated workflows and compliance-ready features help reduce delays and strengthen financial operations.",
            activecontent:"Faster payment collection from customers Unified view of customer balances. dues and credits,Automated payment reminders and notifications,Live dashboards for customer payment visibility,Better cash flow forecasting with upcoming payment insights",
            icon: "bi bi-wallet2",
          },
        ],
      },
    ],
    underLine: "<hr/>",
  },
  {
    mainHeading: "Asset Management",
    cardContent: [
      {
        title: "Asset Management Software, Smarter Way to Control and Maintain Assets",
        titleContent:
          "Track and manage all your assets in real time through a powerful, feature-rich platform.",
        points: [
          {
            pcontent: "Asset Procurement",
            pcontents: "Asset Procurement",
            paracontent:"Streamline asset procurement and onboarding with a smart Asset Acquisition module designed for accuracy, speed, and control. From bulk imports to compliance-ready tracking, every asset is captured with complete visibility.",
            activecontent:"Automated PO creation and asset inwarding,Flexible quality inspection during receipt,Bulk asset onboarding and legacy asset imports,Barcode and QR code tagging for every asset,Asset photo documentation for verification,Detailed tracking of owned and leased assets",
            icon: "bi bi-building",
          },
          {
            pcontent: "Smart Asset Tracking",
            pcontents: "Smart Asset Tracking",
            paracontent:"Smart Asset Tracking helps organizations maintain complete control over asset movement and allocation by providing detailed tracking at every level.",
            activecontent:"Barcode and QR code–enabled asset identification,Location-based asset tracking,Group-wise and subgroup-wise asset monitoring,Fast and secure bulk asset transfers",
            icon: "bi bi-upc-scan",
          },
          {
            pcontent: "Warranty, Insurance & Deployment Tracking",
            pcontents: "Warranty, Insurance & Deployment Tracking",
            paracontent:"Manage asset protection and deployment efficiently by maintaining complete warranty, insurance, and installation records in one centralized system. Automated alerts ensure you never miss critical renewals or milestones.",
            activecontent:"Record and manage asset warranty information,Maintain extended warranty coverage details,Receive automatic reminders for warranty renewals,Capture and track asset insurance information,Get automated alerts for insurance renewals,Monitor and track asset installation status",
            icon: "bi bi-shield-exclamation",
          },
          {
            pcontent: "Asset Servicing & Maintenance Tracking",
            pcontents: "Asset Servicing & Maintenance Tracking",
            paracontent:"Ensure optimal asset performance by planning, tracking, and managing all servicing and maintenance activities from a centralized platform. Automated alerts and detailed tracking help reduce downtime and extend asset life.",
            activecontent:"Plan and schedule maintenance in advance,Create service tickets for asset issues,Track ongoing and completed service activities,Request and issue repair materials seamlessly,Track consumable consumption per asset,Get proactive alerts for scheduled maintenance",
            icon: "bi bi-wrench-adjustable",
          },
          {
            pcontent: "Asset Verification & Audit Management",
            pcontents: "Asset Verification & Audit Management",
            paracontent:"Maintain compliance and accuracy with structured asset verification tools that enable mobile audits, real-time tagging, and instant reporting.",
            activecontent:"Simplified asset verification workflows,Asset audit list preparation and execution,Mobile-based verification with minimal effort,QR code–enabled verification for accuracy,Faster audit completion with digital processes,Damage identification during verification",
            icon: "bi bi-file-earmark-check",
          },
          {
            pcontent: "Smart Asset Depreciation",
            pcontents: "Smart Asset Depreciation",
            paracontent:"Simplify asset value tracking with an automated depreciation framework designed for accuracy and compliance. The module supports multiple depreciation scenarios, helping organizations manage asset lifecycles efficiently while meeting statutory and internal policy requirements.",
            activecontent:"Set flexible depreciation rules across asset categories,Depreciate assets at group and sub-group levels,Calculate depreciation using residual asset values,Start depreciation from the installation date,Apply income tax–compliant depreciation methods,Configure depreciation as per company accounting policies",
            icon: "bi bi-graph-down",
          },
          {
            pcontent: "Audit-Friendly Reporting",
            pcontents: "Audit-Friendly Reporting",
            paracontent:"Access accurate, real-time asset reports that simplify compliance, improve control, and support better financial planning.",
            activecontent:"Company policy–based depreciation reports,Income tax–compliant depreciation summaries,Asset purchase and disposal reports,180-day asset usage classification reports,Asset registers by location and employee,Fully customizable reporting formats,One-click export to Excel. CSV & PDF,Scheduled and automatic email reports",
            icon: "bi bi-file-earmark-bar-graph",
          },
        ],
      },
    ],
    underLine: "<hr/>",
  },
  {
    mainHeading: "Production Management",
    cardContent: [
      {
        title: "Centralized Control Across the Production Lifecycle.",
        titleContent: "Oversees and automates manufacturing processes.",
        points: [
          {
            pcontent: "Product Info Center",
            pcontents: "Product Info Center",
            paracontent:"Maintain a single source of truth for product-related information while supporting collaboration and operational efficiency across departments.",
            activecontent:"Capture and store complete electronic product data,Manage product information across the entire lifecycle,Reuse product data in design, Manufacturing and distribution,Enable cross-functional collaboration with built-in tools,Provide self-service access to technical specifications",
            icon: "bi bi-archive",
          },
          {
            pcontent: "Digital Work Order Control",
            pcontents: "Digital Work Order Control",
            paracontent:"Simplify your production operations with an intelligent work order management system built to handle complex manufacturing requirements. VENSAP ensures accurate batch formation, real-time tracking, and seamless production execution.",
            activecontent:"Efficient handling of work orders across production stages,Automated batch development,Real-time production visibility,Improved traceability and compliance,Optimized production control",
            icon: "bi bi-gear-wide-connected",
          },
          {
            pcontent: "Production Scheduling & Optimization",
            pcontents: "Production Scheduling & Optimization",
            paracontent:"VENSAP advanced planning and scheduling capabilities help manufacturers meet customer demand efficiently and cost-effectively. By optimizing material procurement, inventory placement, and machine or workstation scheduling, the system ensures smooth operations and on-time delivery.",
            activecontent:"Accurate planning of material purchases,Optimized inventory allocation across locations,Efficient scheduling of machines and workstations,Improved production flow and reduced delays,Consistent on-time order fulfillment",
            icon: "bi bi-calendar2-check",
          },
          {
            pcontent: "Manufacturing Process & Routing",
            pcontents: "Manufacturing Process & Routing",
            paracontent:"Manage and control the exact sequence of operations required to manufacture a product. With dynamic routing capabilities, production teams can adjust workflows in real time without disrupting operations.",
            activecontent:"Centralized process and routing master,Dynamic routing updates,Greater production flexibility",
            icon: "bi bi-diagram-2",
          },
          {
            pcontent: "Manufacturing Cost Control",
            pcontents: "Manufacturing Cost Control",
            paracontent:"Gain precise control over manufacturing costs by capturing every cost component involved in production and reconciling them against planned budgets.",
            activecontent:"Track real-time production costs,Monitor overheads and material wastage,Compare standard costs with actual expenses,Identify cost variances and inefficiencies,Improve margin and profitability control",
            icon: "bi bi-cash-coin",
          },
          {
            pcontent: "Location-Based Manufacturing Control",
            pcontents: "Location-Based Manufacturing Control",
            paracontent:"Gain precise control over manufacturing costs by capturing every cost component involved in production and reconciling them against planned budgets.",
            activecontent:"Location-wise production planning and tracking,Better coordination between manufacturing units,Reduced operational complexity,Enhanced operational visibility",
            icon: "bi bi-map",
          },
        ],
      },
    ],
    underLine: "<hr/>",
  },
  {
    mainHeading: "AP Automation",
    cardContent: [
      {
        title: "Intelligent Automation for Accounts Payable.",
        titleContent:
          "Digitizes invoice approvals and automated payment processing.",
        points: [
          {
            pcontent: "Fast & Ready E-Invoice Software",
            pcontents: "Fast & Ready E-Invoice Software",
            paracontent:"Designed for businesses of all sizes, this e-invoice solution enables rapid deployment, real-time processing, and secure GST-compliant invoicing with minimal effort.",
            activecontent:"Multiple GST number management,Centralized and intuitive control panel,Real-time invoice creation and print capability,Supports all government-mandated e-invoice formats,Quick invoice cancellation workflow,Enterprise-grade security standards",
            icon: "bi bi-receipt",
          },
          {
            pcontent: "Simplified Implementation & Integration",
            pcontents: "Simplified Implementation & Integration",
            activecontent:"Compatible with all ERP platforms,Economical pricing model,Intelligent controls to avoid duplication,Reduced operational and processing costs,Comprehensive IRN-compliant GST invoicing framework",
            paracontent:"Built for enterprises, this solution ensures a smooth rollout, seamless ERP integration, and accurate GST invoicing while improving efficiency and reducing costs.",
            icon: "bi bi-gear-wide-connected",
          },
          {
            pcontent: "Complete GST Invoicing Solution",
            pcontents: "Complete GST Invoicing Solution",
            paracontent:"comprehensive invoicing solution that supports bulk processing, automation, and compliance—built to work effortlessly",
            activecontent:"Bulk invoice upload facility,Built-in error validation checks,Role-based custom user views,Automatic IRN creation,Smooth GST invoicing integration with ERP billing",
            icon: "bi bi-layout-text-window-reverse",
          },
        ],
      },
    ],
    underLine: "<hr/>",
  },
  {
    mainHeading: "Product Hub and Life Cycle",
    cardContent: [
      {
        title: "Product Hub & Lifecycle Management centralizes all product information in one place, ensuring consistency and visibility across departments throughout the product’s lifecycle.",
        // titleContent: "Centralizes all data related to a product's lifecycle.",
        points: [
          {
            pcontent: "Centralized Data Management",
            pcontents: "Centralized Data Management",
            paracontent:"All business data is stored in one system to avoid duplication and ensure consistency.",
            activecontent:"Single source of truth for all business data,Eliminates duplicate entries across departments,Improves data accuracy and consistency,Enables easy access to information anytime",
            icon: "bi bi-database",
          },
          {
            pcontent: "User Roles & Access Control",
            pcontents: "User Roles & Access Control",
            paracontent:"Different access levels based on roles to maintain data security and control.",
            activecontent:"Role-based permissions for users,Protects sensitive business data,Controls who can view / edit or approve data,Ensures compliance with internal policies",
            icon: "bi bi-key",
          },
          {
            pcontent: "Real-Time Reporting & Dashboards",
            pcontents: "Real-Time Reporting & Dashboards",
            paracontent:"Live reports and dashboards for quick decision-making.",
            activecontent:"Live visibility into business operations,Customizable dashboards for different teams,Faster and data-driven decision making,Easy export of reports in multiple formats",
            icon: "bi bi-speedometer2",
          },
          {
            pcontent: "Workflow Automation",
            pcontents: "Workflow Automation",
            paracontent:"Automates approvals and routine business processes to save time and reduce errors.",
            activecontent:"Automates approvals and routine tasks,Reduces manual errors and processing time,Improves operational efficiency,Ensures process consistency across teams",
            icon: "bi bi-lightning-charge",
          },
        ],
      },
    ],
    underLine: "<hr/>",
  },
  {
    mainHeading: "Logistics Management",
    cardContent: [
      {
        title: "Real-Time Control for Modern Logistics.",
        titleContent: "Automates transportation and supply chain movement.",
        points: [
          {
            pcontent: "Order Processing",
            pcontents: "Order Processing",
            paracontent:"Efficient order processing bridges customer demand with inventory availability, enabling smooth and timely delivery of goods.",
            activecontent:"Quick order validation,Inventory-linked fulfillment,Faster dispatch cycles,Centralized order handling",
            icon: "bi bi-cart-check",
          },
          {
            pcontent: "Product & Material Handling",
            pcontents: "Product & Material Handling",
            paracontent:"Product handling ensures smooth internal logistics operations by managing how goods are moved, lifted, stored, and transferred.",
            activecontent:"Improved operational efficiency,Reduced handling losses,Better equipment usage,Reduced operational costs",
            icon: "bi bi-check-square-fill",
          },
          {
            pcontent: "Inventory Control Management",
            pcontents: "Inventory Control Management",
            paracontent:"Smart inventory control helps businesses respond quickly to demand while minimizing waste and excess stock.",
            activecontent:"Balanced inventory levels,Reduced holding costs,Improved order accuracy,Demand-driven replenishment",
            icon: "bi bi-stack",
          },
          {
            pcontent: "Storage & Warehouse Management",
            pcontents: "Storage & Warehouse Management",
            paracontent:"Warehouse management organizes goods efficiently to improve space utilization, accessibility, and order fulfillment speed.",
            activecontent:"Optimized warehouse layout,Lower operational costs,Improved inventory accuracy",
            icon: "bi bi-building",
          },
          {
            pcontent: "Supply Chain Data & Monitoring",
            pcontents: "Supply Chain Data & Monitoring",
            paracontent:"Supply chain monitoring provides real-time visibility into logistics operations, enabling data-driven decisions.",
            activecontent:"Live inventory tracking,Smarter planning,Demand forecasting,Operational insights",
            icon: "bi bi-activity",
          },
        ],
      },
    ],
    underLine: "<hr/>",
  },
  {
    mainHeading: "Supply Inventory Management",
    cardContent: [
      {
        title: "Inventory Management Software,Empowering Businesses to Scale with Confidence",
        titleContent:
          "Monitor and manage inventory from anywhere with a smart, cloud-based inventory management module.",
        points: [
          {
            pcontent: "Advanced Warehouse Inventory Management",
            pcontents: "Advanced Warehouse Inventory Management",
            paracontent:"Automated warehouse inventory management helps businesses streamline stock operations by reducing manual effort and improving accuracy. With real-time tracking and intelligent automation, organizations can manage inventory efficiently from goods receipt to final dispatch while maintaining complete visibility across the warehouse.",
            activecontent:"End-to-end automation covering inwarding storage and dispatch of goods,Barcode and QR code–based identification for fast and accurate inventory tracking,Automatic generation of purchase requirements based on current stock levels",
            icon: "bi bi-box-seam",
          },
          {
            pcontent: "Enhanced Workflow Efficiency",
            pcontents: "Enhanced Workflow Efficiency",
            paracontent:"A smart workflow reduces manual effort and improves efficiency across warehouse operations. It ensures inventory is always in the right place and tasks are assigned effectively, leading to improved service levels and reduced operational costs.",
            activecontent:"Quicker access to inventory items,Strategic placement of high-demand stock,Improved stock management with tighter controls,Enhanced employee productivity through smart task allocation",
            icon: "bi bi-gear-wide-connected",
          },
          {
            pcontent: "Advanced Inventory Turnover Management",
            pcontents: "Advanced Inventory Turnover Management",
            paracontent:"Advanced inventory turnover management enables organizations to maintain lean inventory while meeting customer demand efficiently. By combining real-time analytics with automated reporting, businesses can improve outcomes across procurement and operations.",
            activecontent:"Analyze performance to focus on high-value and high-demand products,Use accurate inventory data to negotiate better terms with vendors,Minimize waste by identifying slow-moving or excess stock,Generate real-time closing stock reports instantly",
            icon: "bi bi-graph-up-arrow",
          },
          {
            pcontent: "Strategic Business Value",
            pcontents: "Strategic Business Value",
            paracontent:"A well-managed inventory system strengthens brand presence by ensuring smooth operations and dependable service delivery. Businesses gain better control, improved relationships, and the flexibility to invest more in growth-oriented marketing.",
            activecontent:"Improved customer service through real-time inventory accuracy,Stronger vendor collaboration driven by reliable stock data,Complete inventory visibility with end-to-end tracking,Cost savings that can be redirected into marketing initiatives",
            icon: "bi bi bi-bullseye",
          },
        ],
      },
    ],
    underLine: "<hr/>",
  },
  {
    mainHeading: "Profit Ledger",
    cardContent: [
      {
        title: "Clear Visibility Into Profit Performance.",
        titleContent:
          "Optimizes financial visibility and operational profitability.",
        points: [
          {
            pcontent: "Estimates & sales orders",
            pcontents: "Estimates & sales orders",
            paracontent:"Our Profit Ledger enables organizations to measure operational profitability accurately by consolidating financial data across departments, locations, and transactions.",
            activecontent:"Consolidated profit and loss view,Automated financial data aggregation,Multi-level profitability analysis,Detailed profit reports for audits and reviews,Strategic insights to improve margins",
            icon: "bi bi-person-plus",
          },
          {
            pcontent: "Automated Invoice Reminders",
            pcontents: "Automated Invoice Reminders",
            paracontent:"Get paid on time without chasing customers. VENSAP automatically sends reminder emails for pending invoices, reducing delays and improving cash flow.",
            activecontent:"Automatically send payment reminders to customers,Reduce manual follow-ups and save time,Improve on-time payments and cash flow,Schedule reminders based on due dates,Minimize overdue and outstanding invoices",
            icon: "bi  bi-bell",
          },
          {
            pcontent: "Bank Statement Reconciliation",
            pcontents: "Bank Statement Reconciliation",
            paracontent:"Automate and streamline the bank reconciliation process by matching bank statements with system transactions to ensure accuracy, reduce manual effort, and maintain complete financial control.",
            activecontent:"Automatic matching of bank and system entries,Quick identification of mismatches and errors,Reduced manual reconciliation effort,Improved accuracy and financial transparency.Faster month-end and year-end closing",
            icon: "bi  bi-bank",
          },
          {
            pcontent: "Project Management & Tracking",
            pcontents: "Project Management & Tracking",
            paracontent:"Manage projects efficiently by planning tasks, allocating resources, and tracking progress and costs to ensure timely delivery and better operational control.",
            activecontent:"controlProject planning and task management,Resource allocation and workload tracking,Real-time project progress monitoring,Cost and budget tracking,Improved collaboration and on-time delivery",
            icon: "bi  bi-kanban",
          },
          {
            pcontent: "Auditor Access & Collaboration",
            pcontents: "Auditor Access & Collaboration",
            paracontent:"Simplify audit processes by providing secure and controlled access to auditors, ensuring transparency, compliance, and smooth collaboration throughout the audit cycle.",
            activecontent:"Secure auditor access to financial records,Controlled sharing of reports and documents,Real-time audit tracking and visibility,Reduced audit turnaround time,Improved compliance and data integrity",
            icon: "bi bi-person-check",
          },
          {
            pcontent: "Chart of Accounts Management",
            pcontents: "Chart of Accounts Management",
            paracontent:"Organize and control your financial structure with a well-defined chart of accounts that ensures accurate recording, reporting, and compliance across your accounting system.",
            activecontent:"Structured listing of all financial accounts,Easy categorization of assets, liabilities income. and expenses,Supports multi-level account grouping,Ensures consistency in financial reporting,Simplifies audit and compliance requirements.",
            icon: "bi bi-diagram-3",
          },
          {
            pcontent: "Journal Entry Management",
            pcontents: "Journal Entry Management",
            paracontent:"Record and manage all financial transactions accurately with a flexible journal entry system that supports day-to-day accounting and period-end adjustments.",
            activecontent:"Manual and automated journal entries,Support for adjustment, accrual, and reversal entries,Date-wise and account-wise transaction tracking,Improved accuracy in financial records,Seamless integration with ledgers and reports.",
            icon: "bi  bi-journal-text",
          },
        ],
      },
    ],
    underLine: "",
  },
];
const Features = () => {
  const initialVisibility = featureData.map(() => 0); // Default to first item visible
  const [visibleContent, setVisibleContent] = useState(initialVisibility);

  const handleToggleContent = (cardIndex, pointIndex) => {
    const updatedVisibility = [...visibleContent];
    updatedVisibility[cardIndex] = pointIndex;
    setVisibleContent(updatedVisibility);
  };

  const [getPopUpShow, setPopUpShow] = useState(false);
  const onhide = () => {
    setPopUpShow(false);
  };
  const handelclick = () => {
    setPopUpShow(true);
  };
  return (
    <>
      <PopupModal show={getPopUpShow} onHide={onhide} />
      <div className="features">
        <div className="heading">
          <div className="pocure-to-pay-heading">
            <h1 className="text-center mb-4">
              Platform Features Overview
            </h1>
          </div>
          <Row className="container-fluid">
            <Col
              xs={{ span: 2, offset: 5 }}
              md={{ span: 1, offset: 4 }}
              lg={{ span: 1, offset: 5 }}
              className=" d-flex justify-content-center my-2"
            >
              <div className="main-btn" onClick={handelclick}>
                Book a Demo
              </div>
            </Col>

            <Col
              xs={12}
              md={4}
              lg={2}
              className="d-flex justify-content-center my-2"
            >
              <div className="main-btn" onClick={handelclick}>
                Request Pricing
              </div>
            </Col>
          </Row>
        </div>
        <div className="container Purchasing">
          <Row>
            {featureData.map((data, i) => (
              <React.Fragment key={i}>
                <Col
                  xs={12}
                  md={12}
                  lg={12}
                  className="container d-flex justify-content-start"
                >
                  <div className="Purchasing-heading">
                    <p>{data.mainHeading}</p>
                  </div>
                </Col>
                {data.cardContent.map((item, j) => (
                  <Col
                    xs={12}
                    md={12}
                    lg={12}
                    className="container d-flex justify-content-center"
                    key={j}
                  >
                    <Col xs={6} md={6} lg={6} className="card-title content">
                      <div className="card-head fw-medium">
                        <p className="fs-5"> {item.title}</p>
                      </div>
                      <div className="card-head">
                        <p>{item.titleContent}</p>
                      </div>
                      {item.points.map((point, k) => (
                        <div
                          className={`card-titles d-flex justify-content-end align-items-center ${
                            visibleContent[i] === k ? "active" : ""
                          }`}
                          key={k}
                          onClick={() => handleToggleContent(i, k)}
                        >
                          <p>{point.pcontent}</p>
                          <i className={point.icon}></i>
                        </div>
                      ))}
                    </Col>
                    {/* {item.points.map((point, k) => (
                      <Col
                        xs={6}
                        md={6}
                        lg={6}
                        className="card-title-content"
                        key={k}
                        style={{
                          display: visibleContent[i] === k ? "block" : "none",
                        }}
                      >
                        <p>{point.pcontents}</p>
                        <p>{point.activecontent}</p>
                      </Col>
                    ))} */}
                    {item.points.map((point, k) => (
                      <Col
                        xs={6}
                        md={6}
                        lg={6}
                        className="card-title-content"
                        key={k}
                        style={{
                          display: visibleContent[i] === k ? "block" : "none",
                        }}
                      >
                        <p>{point.pcontents}</p>
                        <p>{point.paracontent}</p>
                        {point.activecontent ? (
                          <ul className="active-points">
                            {point.activecontent
                              .split(",")
                              .map((bulletPoint, index) => (
                                <li key={index}>{bulletPoint.trim()}</li>
                              ))}
                          </ul>
                        ) : null}
                      </Col>
                    ))}
                  </Col>
                ))}
                <div dangerouslySetInnerHTML={{ __html: data.underLine }} />
              </React.Fragment>
            ))}
          </Row>
        </div>
      </div>
    </>
  );
};
export default Features;
